module.exports = __webpack_public_path__ + "assets/img/1.f47d8094.jpg";